import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DataForSEOHealthResponse {
  success: boolean;
  data: {
    healthy: boolean;
    message: string;
  };
  timestamp: string;
}

@Injectable({
  providedIn: 'root'
})
export class DataForSEOService {
  private readonly API_URL = environment.apiUrl + '/v1';

  constructor(private http: HttpClient) {}

  /**
   * Test DataForSEO connection
   * 
   * TODO: This is where we'll gather data for each URL for now
   * - Replace this simple health check with actual OnPage API calls
   * - Implement URL analysis with DataForSEO OnPage API
   * - Store results in database for each URL
   * 
   * TODO: The button will not stay, it will be automatically retrieved every X days
   * - Implement scheduled background jobs to fetch data automatically
   * - Remove manual "Fetch" button once automation is in place
   * - Set up cron jobs or similar for regular data updates
   */
  testConnection(): Observable<DataForSEOHealthResponse> {
    return this.http.get<DataForSEOHealthResponse>(`${this.API_URL}/dataforseo/health`);
  }

  /**
   * Get analysis for a specific URL from our database
   */
  getUrlAnalysis(url: string): Observable<any> {
    const encodedUrl = encodeURIComponent(url);
    return this.http.get<any>(`${this.API_URL}/urls/analysis?url=${encodedUrl}`);
  }

  /**
   * Analyze a specific URL (placeholder for future implementation)
   * TODO: Implement actual OnPage API calls for URL analysis
   * - Use DataForSEO OnPage API endpoints
   * - Fetch page screenshots, content analysis, SEO metrics
   * - Store comprehensive analysis results
   */
  analyzeUrl(url: string): Observable<any> {
    // TODO: This will be implemented with actual DataForSEO OnPage API calls
    return new Observable(subscriber => {
      subscriber.next({
        success: true,
        data: {
          message: 'URL analysis not yet implemented',
          url: url
        }
      });
      subscriber.complete();
    });
  }
} 